import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from '@gs1france/gs1-components-library';
import {UserSvc} from '../../../../../shared/services';

@Component({
  selector: 'app-new-feature-modal',
  templateUrl: './new-feature-modal.component.html',
  styleUrls: ['./new-feature-modal.component.less']
})
export class NewFeatureModalComponent implements AfterViewInit {
  public htmlModal = '<div>Intégrez un lien « En savoir plus » sur la page réglementaire de votre produit accessible via votre QR Code augmenté GS1.'
    + '<br> Vous pouvez ajouter ce lien ou créer votre QR Code directement depuis vos fiches produit dans CodeOnline.</div>';
  @ViewChild('directiveVCSRef', { static: false }) public newVCSFeatureModal: ModalDirective;
  constructor(public userSvc: UserSvc) { }

  public ngAfterViewInit() {
    this.openModal();
  }

  public openModal() {
    this.newVCSFeatureModal.openDialog();
  }

  public validateDisclaimer(disclaimerAccepted: boolean) {
    this.userSvc.updateUser({hasSeenVCSProduct: disclaimerAccepted}).then(() => {
      console.info('User updated: Has seen V&S product');
    });
  }

}
